import { firebase } from "../lib/firebase";

export async function GetProjectsDetails() {
  try {
    const projectsData = await getProjectsData();
    if (projectsData && projectsData.length > 0) {
      const creativeCodingProjects = projectsData.filter(
        (pro) => pro?.type && pro.type === "creativecoding"
      );
      const otherProjects = projectsData.filter(
        (pro) => !(pro?.type && pro.type === "creativecoding")
      );
      return [...creativeCodingProjects, ...otherProjects];
    }
    return [];
  } catch (err) {
    console.log(err.message);
    return [];
  }
}

export async function getProjectsData() {
  try {
    const result = await firebase
      .firestore()
      .collection("portfolio")
      .doc("projects")
      .collection("projects-data")
      .get();
    return result.docs.map((pro) => ({ ...pro.data(), proId: pro.id }));
  } catch (err) {
    console.log(err.message);
    return [];
  }
}

export async function getExperincesData() {
  try {
    const result = await firebase
      .firestore()
      .collection("portfolio")
      .doc("experinces")
      .collection("experinces-data")
      .get();
    return result.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
  } catch (err) {
    console.log(err.message);
    return [];
  }
}

export async function getTestimonialsData() {
  try {
    const result = await firebase
      .firestore()
      .collection("portfolio")
      .doc("testimonials")
      .collection("testimonials-data")
      .get();
    return result.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
  } catch (err) {
    console.log(err.message);
    return [];
  }
}

export async function GetAchievementsDetails() {
  try {
    const achivementsData = await getAchievementsData();
    return achivementsData;
  } catch (error) {
    console.log(error.message);
    return [];
  }
}
export async function getAchievementsData() {
  try {
    const result = await firebase
      .firestore()
      .collection("portfolio")
      .doc("achievements")
      .collection("achievements-section")
      .get();
    return result.docs.map((achi) => ({ ...achi.data() }));
  } catch (err) {
    console.log(err.message);
    return [];
  }
}

export async function GetBlogsDetails() {
  try {
    const result = await firebase
      .firestore()
      .collection("portfolio")
      .doc("blogs")
      .collection("blogs-data")
      .get();
    return result.docs.map((blog) => ({ ...blog.data(), blogId: blog.id }));
  } catch (err) {
    console.log(err.message);
    return [];
  }
}

export async function GetResumeURL() {
  try {
    const result = await firebase
      .storage()
      .ref("portfolio")
      .child("resume")
      .listAll();

    return await Promise.all(result.items.map((file) => file.getDownloadURL()));
  } catch (err) {
    console.log(err.message);
    return [];
  }
}
